/**
 * RegExp matching URI protocol (ex: `http://` or `doi:`) at the start of strings.
 * Also accepts non standard `//` and `://` protocols.
 */
const URI_PROTOCOL_REGEXP = /^([A-Za-z]{3,9}:(?:\/\/)?|:?\/\/)/;

/**
 * Prefixes non absolute URL with `//`.
 */
export const getProtocolRelativeUrl = (url?: string) => {
    if (url && !url.match(URI_PROTOCOL_REGEXP)) {
        return `//${url}`;
    }
    return url;
};
